// extracted by mini-css-extract-plugin
export default {"root":"Rules_root__i3MFM","wrapper":"Rules_wrapper__tHnOZ","fadeUp":"Rules_fadeUp__YEK2X","actions":"Rules_actions__LE9in","footer":"Rules_footer__lMaB7"};